// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_37-1";
export var rateTableServiceLevelDropdown = "_37-3";
export var rateTableTypeDropdown = "_37-0";
export var rateTableValueModeDropdown = "_37-2";